export default {
    gaugeArea: {
        type: Object,
        default: undefined
    }, 
    pointer: {
        type: Array,
        default: undefined
    }, 
    renderAs: {
        type: String,
        default: undefined
    }, 
    scale: {
        type: Object,
        default: undefined
    }, 
    transitions: {
        type: Boolean,
        default: undefined
    }

    // Events
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/KendoRadialGauge/RadialGaugeProps.js